import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { InvoiceDetailViewModel, PrintSaleFactorAction } from "src/Sell/invoiceDetail/invoiceDetail-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { CashOnDeliveryPaymentViewModel } from "../cashOnDeliveryPayment/cashOnDeliveryPayment-viewModel";
import { CashPaymentViewModel } from "../cashPayment/cashPayment-viewModel";
import { CreditPaymentViewModel } from "../creditPayment/creditPayment-viewModel";
import { DebitPaymentViewModel } from "../debitPayment/debitPayment-viewModel";
import { IbanPaymentViewModel } from "../ibanPayment/ibanPayment-viewModel";
import { PosPaymentViewModel } from "../posPayment/posPayment-viewModel";
import  { InvoicePaymentView } from "./invoicePayment-view"

export class InvoicePaymentViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: InvoiceDetailViewModel) {
        super(parentViewModel);
        this.paymentMethods = ObservableArray.create<IPaymentMethod>();
        this.payments = ObservableArray.create<singlePayment>();
        this._parent = parentViewModel;
    }
    closePopup(message?:string) {
    }
    GetDefaultView(): View <ViewModel> {
        return new InvoicePaymentView();
    }
    public getTypeId(): string {
        return "VM-3E26F80F-B838-4417-ADEA-8B272D1E78F6"
    }

    private _parent: InvoiceDetailViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set payedAmount(v: number) { this._payedAmount = v; } public get payedAmount(): number { return this._payedAmount;} private _payedAmount: number;
    public set invoiceAmount(v: number) { this._invoiceAmount = v; } public get invoiceAmount(): number { return this._invoiceAmount;} private _invoiceAmount: number;
    public set remainingAmount(v: number) { this._remainingAmount = v; } public get remainingAmount(): number { return this._remainingAmount;} private _remainingAmount: number;
    public set realRemainingAmount(v: number) { this._realRemainingAmount = v; } public get realRemainingAmount(): number { return this._realRemainingAmount;} private _realRemainingAmount: number;
    public set realPaidAmount(v: number) { this._realPaidAmount = v; } public get realPaidAmount(): number { return this._realPaidAmount;} private _realPaidAmount: number;
    public set customerCredit(v: number) { this._customerCredit = v; } public get customerCredit(): number { return this._customerCredit;} private _customerCredit: number;
    public set customerAccountBalance(v: number) { this._customerAccountBalance = v; } public get customerAccountBalance(): number { return this._customerAccountBalance;} private _customerAccountBalance: number;
    public set remainingAmountWithCredit(v: number) { this._remainingAmountWithCredit = v; } public get remainingAmountWithCredit(): number { return this._remainingAmountWithCredit;} private _remainingAmountWithCredit: number;
    
    public set payments(v: ObservableArray<singlePayment>) { this._payments = v; } public get payments(): ObservableArray<singlePayment> { return this._payments;} private _payments: ObservableArray<singlePayment>;
    public set paymentMethods(v: ObservableArray<IPaymentMethod>) { this._paymentMethods = v; } public get paymentMethods(): ObservableArray<IPaymentMethod> { return this._paymentMethods;} private _paymentMethods: ObservableArray<IPaymentMethod>;
    public set selectedPaymentMethod(v: IPaymentMethod) { 
        this._selectedPaymentMethod = v; 
        this.selectedPaymentMethod?.load();
    } public get selectedPaymentMethod(): IPaymentMethod { return this._selectedPaymentMethod;} private _selectedPaymentMethod: IPaymentMethod;
    public set invoiceId(v: string) { 
        this._invoiceId = v;
        this.load();
    } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isFromRootDistrict(v: boolean) { this._isFromRootDistrict = v; } public get isFromRootDistrict(): boolean { return this._isFromRootDistrict;} private _isFromRootDistrict: boolean;
    public set paymentState(v: number) { this._paymentState = v; } public get paymentState(): number { return this._paymentState;} private _paymentState: number;
    public set paymentNotComplete(v: boolean) { this._paymentNotComplete = v; } public get paymentNotComplete(): boolean { return this._paymentNotComplete;} private _paymentNotComplete: boolean;
    public set canCashOnDelivery(v: boolean) { this._canCashOnDelivery = v; } public get canCashOnDelivery(): boolean { return this._canCashOnDelivery;} private _canCashOnDelivery: boolean;
    
    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SellServices/GetInvoiceDetail',{
                InvoiceId:this.invoiceId
            });
            this.invoiceAmount = result.FinalPrice;
            this.paymentState = result.PaymentState;
            this.paymentNotComplete = this.paymentState == 0 || this.paymentState == 1 || this.paymentState == 2;
            this.isFromRootDistrict = result.IsFromRootDistrict;
            this.canCashOnDelivery = result.CanCashOnDelivery;
            this.payments.update(...result.Payments.map((x,i)=>{
                let r = new singlePayment(this);
                r.index = i+1;
                r.amount = x.Amount;
                r.method = x.MethodName;
                r.methodNo = x.MethodNo;
                r.time = moment.utc(x.Time);
                if(x.Status==1){
                    r.setConfirmationStatus(null);
                }else if(x.Status==2){
                    r.setConfirmationStatus(true);
                }else{
                    r.setConfirmationStatus(false);
                }
                return r;
            }));
            await this.calculateRemaining();
            await this.createMethods();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    createMethods() {
        if(this.isFromRootDistrict){
            this.paymentMethods.update(...[
                //new PosPaymentViewModel(this),
                new IbanPaymentViewModel(this),
                new DebitPaymentViewModel(this),
                new CashPaymentViewModel(this),
            ]);
            if (this.canCashOnDelivery) {
                this.paymentMethods.push(...[new CashOnDeliveryPaymentViewModel(this)]);
            }
        }else{
            this.paymentMethods.update(...[
                new DebitPaymentViewModel(this),
                new CashPaymentViewModel(this),
                new CreditPaymentViewModel(this)
            ]);
        }
        if (this.paymentNotComplete) {
            this.paymentMethods.push(...[new CreditPaymentViewModel(this)]);
        }
        this.selectedPaymentMethod = this.paymentMethods[0];
        this.updateMethodsInfo();
    }
    private updateMethodsInfo(){
        this.paymentMethods.forEach(x=>{
            x.clear();
            x.onNewPaymentCreated = (q=>this.newPaymentAdded(q));
            x.isFromRootDistrict = this.isFromRootDistrict;
            x.invoiceId = this.invoiceId;
            if(x instanceof CashOnDeliveryPaymentViewModel){
                x.maxAmount = this.remainingAmount;
            }else{
                x.maxAmount = this.realRemainingAmount;
            }
        });
    }
    private async newPaymentAdded(payment:singlePayment){
        payment.index = this.payments.length+1;
        this.payments.push(payment);
        await this.calculateRemaining();
        this.updateMethodsInfo();
    }

    private async loadCredit(){
        let result = await ServerConnection.callServer('/Complex/CreditServices/GetCustomerCredit',{
            InvoiceId:this.invoiceId,
            IsForDistrictSale : !this.isFromRootDistrict
        });
        this.customerCredit = result.Amount;
        this.customerAccountBalance = result.CustomerAccountBalance;
        
    }
    private async calculateRemaining(){
        await this.loadCredit();
        let oldRemainingAmount = this.remainingAmount;
        this.payedAmount = this.payments.reduce((a,c)=>a+(c.isConfirmed?c.amount:0),0);
        this.realPaidAmount = this.payments.reduce((a,c)=>a+(c.isConfirmed && c.methodNo !== 14 && c.methodNo !== 11 ?c.amount:0),0);
        this.remainingAmount = this.invoiceAmount - this.payedAmount;
        this.remainingAmountWithCredit = Math.max(this.remainingAmount - Math.max((this.customerCredit - this.customerAccountBalance), 0), 0);
        this.realRemainingAmount = this.invoiceAmount - this.realPaidAmount;
        
        if(oldRemainingAmount > 0 && this.remainingAmount <= 0){
            
            new PrintSaleFactorAction().Print(this._parent,this.invoiceId);
            await this.messageBoxConfirmSuccess('مبلغ فاکتور به تمامی دریافت شد.','تکمیل دریافت');
            this.closePopup('yes');
        }
    }

    close(){
        this.closePopup('yes');
    }

    async pay(){
        this.isLoading = true;
        await this.selectedPaymentMethod.createPayment();
        this.isLoading = false;
    }
}

export interface IPaymentMethod{
    load();
    onNewPaymentCreated(payment:singlePayment);
    createPayment();
    clear();
    get paymentTypeName(): string;
    set isFromRootDistrict(v: boolean);
    set invoiceId(v: string);
    set maxAmount(v: number);
}

export class singlePayment extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set amount(v: number) { this._amount = getAsNumber(v,true); } public get amount(): number { return this._amount;} private _amount: number;
    public set method(v: string) { this._method = v; } public get method(): string { return this._method;} private _method: string;
    public set methodNo(v: number) { this._methodNo = v; } public get methodNo(): number { return this._methodNo;} private _methodNo: number;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    
    public set isConfirmed(v: boolean) { this._isConfirmed = v; } public get isConfirmed(): boolean { return this._isConfirmed;} private _isConfirmed: boolean;
    public set isRejected(v: boolean) { this._isRejected = v; } public get isRejected(): boolean { return this._isRejected;} private _isRejected: boolean;
    public set isWaiting(v: boolean) { this._isWaiting = v; } public get isWaiting(): boolean { return this._isWaiting;} private _isWaiting: boolean;
    
    public setConfirmationStatus(status?:boolean){
        this.isConfirmed = false;
        this.isRejected = false;
        this.isWaiting = false;
        if(status==null){
            this.isWaiting = true;
        }else if(status==true){
            this.isConfirmed = true;
        }else{
            this.isRejected = true;
        }
    }
}